"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
function isButton(value) {
  return value.component === "button";
}
function isLink(value) {
  return value.component === "a";
}
exports.isButton = isButton;
exports.isLink = isLink;
